import { render, staticRenderFns } from "./IncomePayments.vue?vue&type=template&id=2785c2bc&scoped=true&"
import script from "./IncomePayments.vue?vue&type=script&lang=js&"
export * from "./IncomePayments.vue?vue&type=script&lang=js&"
import style0 from "./IncomePayments.vue?vue&type=style&index=0&id=2785c2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2785c2bc",
  null
  
)

export default component.exports